import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initStateObj = {
  functions: [],
  functionMap: {},
  perms: [],
  permMap: {},
  permReady: false,
  livechatPermMap: {},
  marketingPerm: null
};

const initState = Map(initStateObj);

const parseData = res => {
  if (res && res.data) {
    const { features = [], agent_perms = [], extra_perms = [] } = res.data;
    const permList = extra_perms;
    const functionMap = {};
    const permMap = {};
    agent_perms.forEach(p => {
      functionMap[p.key] = p.perms || [];
      permList.push(...p.perms);
    });
    permList.forEach(p => {
      if (p) {
        permMap[p] = true;
      }
    });

    return {
      functions: features,
      perms: permList,
      functionMap,
      permMap,
      permReady: true
    };
  }
  return initState;
};

export const { setFunctions, setLivechatPermMap, setMarketingPerm } = createActions({
  setFunctions: action => {
    return action;
  },
  setLivechatPermMap: action => {
    return action;
  },
  setMarketingPerm: action => action
});

const func = handleActions(
  {
    [setFunctions]: (state, action) => {
      const { payload } = action;
      const functionObj = parseData(payload);
      return state
        .set('functions', functionObj.functions)
        .set('perms', functionObj.perms)
        .set('functionMap', functionObj.functionMap)
        .set('permMap', functionObj.permMap)
        .set('permReady', true);
    },
    [setLivechatPermMap]: (state, action) => {
      const { payload } = action;
      const livechatPermMap = state.get('livechatPermMap');

      return state.set('livechatPermMap', {
        ...livechatPermMap,
        ...payload
      });
    },
    [setMarketingPerm]: (state, action) => {
      const { payload } = action;
      return state.set('marketingPerm', payload);
    }
  },
  initState
);

export default func;
